import ItemSelector from "./ItemSelector";
import { Paper } from "@mui/material";

// This component only exists to avoid requesting the subjects list in the IntraIdSection.
// Requesting the subjects in the IntraIdSection causes the whole component to suspend
// when the filters are updated. This way we only suspend the item selector and can display
// a more localized message.
const SubjectsItemSelector = (props) => {
  return (
    <Paper elevation={5}>
      <ItemSelector items={props.subjects} {...props} />
    </Paper>
  )
};

export default SubjectsItemSelector;
